<template>
  <div v-if="test._id && answer._id">
    <div class="sub-title my-2">
      <mdb-icon icon="chalkboard-teacher" /> 과목(능력단위)명: {{test.name}}
    </div>
    <div :class="`bolder ${isFail && 'red-text'}`">점수 : {{answer.score}} 점</div>
    <div class="clock">제출일: <mdb-icon icon="clock" class="ml-4" /> {{$strDate(answer.regDate)}}</div>
    <mdb-tbl sm>
      <mdb-tbl-head>
        <tr class="title bolder">
          <th class="bolder">평가항목</th>
          <th class="bolder w-10 text-center" >점수</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body v-for="(u, ux) in test.evals" :key="u._id">
          <tr>
            <td colspan="2" class="bolder blue lighten-5">{{u.category}}</td>
          </tr>
          <tr v-for="(c, cx) in u.items" :key="c._id">
            <td>{{c.text}}</td>
            <td class="text-center">{{answer.evals[ux].scores[cx]}}</td>
          </tr>
      </mdb-tbl-body>
    </mdb-tbl>
    <div></div>
    <div></div>
    <div class="my-3 underline title"><mdb-icon far icon="comment-alt" /> 강사의견</div>
    <div class="underline mb-4" v-html="$linebreak(answer.comment)"></div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'AttitudeTestView',
  props: ['test', 'answer'],
  data: () => ({
    TAG: 'AttitudeTestView :'
  }),
  computed: {
    ...mapGetters('training', ['failScore']),
    isFail () {
      return this.answer.score < this.failScore
    }
  }
}
</script>
